export default {
    // R
    recording: 'Recording',

    // S
    submitVideo: 'Submit video',
}
